<template>
  <ViewEntityContainer :entityName="entityName" :identifier="$route.params.categoryId"
    :getMethod="getJobCategoryById" :refreshOnTimestamp="true" :notificationListeners="[srEventKey]"
    :notificationValidator="notificationValidator">
  </ViewEntityContainer>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import SRConst from "@/helpers/Constants/SignalRConstants.js";
import ViewEntityContainer from "@/views/pim/suppliers/ViewEntityContainer.vue";
import EntityNames from "@/helpers/Constants/EntityNames.js";

export default {
  name: "ViewJobCategoryContainer",
  components: {
    ViewEntityContainer,
  },
  mixins: [clientAPI],

  data() {
    return {
      entityName: EntityNames.JobCategory
    };
  },

  methods: {
    notificationValidator(args, identifier) {
      return args && args.jobCategoryId == identifier;
    },
  },

  computed: {
    srEventKey() {
      return SRConst.EventKeys.JobCategoryChange;
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped></style>